// extracted by mini-css-extract-plugin
export var cardIcon = "_79-5";
export var checkboxCard = "_79-0";
export var checkboxCardSelected = "_79-4";
export var disabled = "_79-2";
export var interactive = "_79-1";
export var outerBorder = "_79-3";
export var spacerMedium = "_79-8";
export var spacerSmall = "_79-7";
export var spacerXsmall = "_79-6";